import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './Navbar.css';

const Navbar = () => {
  const [menuOpen, setMenuOpen] = useState(false);

  // Using the same environment variables as in the Login component
  const COGNITO_DOMAIN = process.env.REACT_APP_COGNITO_DOMAIN || 'us-east-1egnwrgpsl.auth.us-east-1.amazoncognito.com';
  const CLIENT_ID = process.env.REACT_APP_COGNITO_CLIENT_ID || '6qbsc7ujekqp6s90q31aao7hp7';
  const REDIRECT_URI = encodeURIComponent(process.env.REACT_APP_COGNITO_REDIRECT_URI || window.location.origin + '/dashboard');

  // We keep this for reference but now use our custom login page instead
  const loginUrl = `https://${COGNITO_DOMAIN}/login?client_id=${CLIENT_ID}&redirect_uri=${REDIRECT_URI}&response_type=code&scope=email+openid+profile`;

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  return (
    <nav className="navbar">
      <div className="navbar-container">
        <div className="nav-left">
          <Link to="/">
            <img
              src="/images/Logo 1.png"
              alt="Pixelate Logo"
              className="nav-logo"
            />
          </Link>
        </div>

        {/* Mobile menu toggle button */}
        <div className="menu-toggle" onClick={toggleMenu}>
          <i className={`fas ${menuOpen ? 'fa-times' : 'fa-bars'}`}></i>
        </div>

        <div className={`nav-right ${menuOpen ? 'active' : ''}`}>
          <ul className="nav-links">
            <li><Link to="/" onClick={() => setMenuOpen(false)}>Home</Link></li>
            <li><Link to="/services" onClick={() => setMenuOpen(false)}>Services</Link></li>
            <li><Link to="/team" onClick={() => setMenuOpen(false)}>Team</Link></li>
            <li><Link to="/contact" onClick={() => setMenuOpen(false)}>Contact</Link></li>
          </ul>
        </div>
      </div>
    </nav>
  );
};

export default Navbar; 